// Activation linking failure copy (PRO-15). Keys are switched per
// `orderLinkedReason` in ActivationErrorModal; the tokens themselves are
// never shown. Copy framed around the Entel alliance — the plan is billed by
// the operator, and in several cases the fix lives on their side.
// PENDING: business review of these texts (PRO-15 AC).
const translations = {
  'Your activation link was already used': {
    en: 'Your activation link was already used',
    es: 'Tu enlace de activación ya fue utilizado',
    pt: 'Seu link de ativação já foi utilizado',
  },
  'This Entel activation was already redeemed on another account. If that account is yours, log in with it — you can recover its password if you need to.': {
    en: 'This Entel activation was already redeemed on another account. If that account is yours, log in with it — you can recover its password if you need to.',
    es: 'Esta activación de Entel ya fue canjeada en otra cuenta. Si esa cuenta es tuya, inicia sesión con ella — puedes recuperar su contraseña si lo necesitas.',
    pt: 'Esta ativação da Entel já foi resgatada em outra conta. Se essa conta for sua, faça login com ela — você pode recuperar a senha se precisar.',
  },
  'Recover that account': {
    en: 'Recover that account',
    es: 'Recuperar esa cuenta',
    pt: 'Recuperar essa conta',
  },
  'Your Entel subscription is no longer active': {
    en: 'Your Entel subscription is no longer active',
    es: 'Tu suscripción de Entel ya no está activa',
    pt: 'Sua assinatura da Entel não está mais ativa',
  },
  'Entel reports this subscription as canceled, so the link can no longer be activated. You can still subscribe directly with us.': {
    en: 'Entel reports this subscription as canceled, so the link can no longer be activated. You can still subscribe directly with us.',
    es: 'Entel indica que esta suscripción fue cancelada, por lo que el enlace ya no puede activarse. Aún puedes suscribirte directamente con nosotros.',
    pt: 'A Entel informa que esta assinatura foi cancelada, então o link não pode mais ser ativado. Você ainda pode assinar diretamente conosco.',
  },
  'View plans': {
    en: 'View plans',
    es: 'Ver planes',
    pt: 'Ver planos',
  },
  'We couldn\'t activate your subscription yet': {
    en: 'We couldn\'t activate your subscription yet',
    es: 'Aún no pudimos activar tu suscripción',
    pt: 'Ainda não conseguimos ativar sua assinatura',
  },
  'A temporary problem kept us from linking your Entel subscription. Your activation is saved — we\'ll retry automatically the next time you log in.': {
    en: 'A temporary problem kept us from linking your Entel subscription. Your activation is saved — we\'ll retry automatically the next time you log in.',
    es: 'Un problema temporal nos impidió vincular tu suscripción de Entel. Tu activación quedó guardada — lo reintentaremos automáticamente la próxima vez que inicies sesión.',
    pt: 'Um problema temporário nos impediu de vincular sua assinatura da Entel. Sua ativação ficou salva — tentaremos novamente de forma automática na próxima vez que você fizer login.',
  },
  'We couldn\'t activate your subscription': {
    en: 'We couldn\'t activate your subscription',
    es: 'No pudimos activar tu suscripción',
    pt: 'Não conseguimos ativar sua assinatura',
  },
  'We couldn\'t link your Entel activation to this account. Please open the activation link from Entel again, or contact Entel support if the problem continues.': {
    en: 'We couldn\'t link your Entel activation to this account. Please open the activation link from Entel again, or contact Entel support if the problem continues.',
    es: 'No pudimos vincular tu activación de Entel a esta cuenta. Abre nuevamente el enlace de activación de Entel o contacta al soporte de Entel si el problema continúa.',
    pt: 'Não conseguimos vincular sua ativação da Entel a esta conta. Abra novamente o link de ativação da Entel ou entre em contato com o suporte da Entel se o problema continuar.',
  },
}

export default translations
